// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2HtUr","head":"Table_head__1-1kj","col":"Table_col__mJbuY"};